import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.423 11.41a.833.833 0 0 1 0 1.18l-5.834 5.833a.833.833 0 0 1-1.178-1.179l4.41-4.41H6.168a.833.833 0 0 1 0-1.667h9.655L11.41 6.756a.833.833 0 0 1 1.178-1.179z",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledRightArrowFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledRightArrowFilled_default = SvgCircledRightArrowFilled;

export { CircledRightArrowFilled_default as default };
